export default "__VITE_ASSET__Djo1jX5G__"